module.exports = __webpack_public_path__ + "static/media/detail12.c61c5a63.jpg";